'use client';

import { useEffect } from 'react';

import { useTranslations } from 'next-intl';

import { useDevErrorReset } from '@/hooks/use-dev-error-reset';
import { captureExceptionToPostHog } from '@/lib/utils/posthog-client';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errorBoundary');

  useEffect(() => {
    captureExceptionToPostHog(error);
  }, [error]);

  useDevErrorReset(reset);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-bold">{t('title')}</h1>
        <p className="text-muted-foreground">{t('description')}</p>
        <button
          onClick={() => reset()}
          className="rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary/90"
        >
          {t('tryAgain')}
        </button>
      </div>
    </div>
  );
}
